import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ResponseUserMenuDto } from '../gd-integrated/dto/core.dto';
import { NestApiProvider } from '../nest-api';
import { ResponseData } from '../nest-responses';

@Injectable()
export class SF7Api {

  private _service: string = '';
  private _model: string = 'core/access';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public userMenu(): Observable<ResponseData<ResponseUserMenuDto[]>> {
    const method: string = 'GET';
    const model: string = this._model;
    const func: string = 'userMenu';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this._service);
    return this.nestApiProvider.request<ResponseData<ResponseUserMenuDto[]>>(method, url, params, urlParams, body, contentType, null, null, false);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/sf7/core.api.ts